(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldTemplate', fbFieldTemplate);

    function fbFieldTemplate() {
        return {
            restrict: 'E',
            scope: {
                element: '='
            },
            controller: fbFieldTemplateCtrl,
            controllerAs: 'vm',
            bindToController: true,
            template: '<div ng-bind-html="vm.element.options.html | trustAsHtml"></div>'
        };
    }

    function fbFieldTemplateCtrl() {
    }
})();